// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__22SBl","bigColWidth":"Table_bigColWidth__3jM-f","biggerColWidth":"Table_biggerColWidth__X0aIz","row":"Table_row__qMa1a","col":"Table_col__3_4Il"};